export default __webpack_public_path__ + "static/media/Redfury War Wolf.ab86a475.jpg";